import { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useNotificationBanner } from 'hooks/notifications/useNotificationBanner';

import { NotificationBanner } from 'components/NotificationBanner';

import { Box, Toolbar } from '@mui/material';

import type { MenuItem } from 'menu-items/types';
import Breadcrumbs from 'ui-elements/@extended/Breadcrumbs';

import navigation from 'menu-items';

const Main = () => {
    const { notification, showBanner, closeBanner } = useNotificationBanner();
    const location = useLocation();

    const isRedesign = location.pathname.includes('links/');

    const flattenedMenuItems = useMemo(() => {
        return navigation.items.flatMap((group) => group.children);
    }, [navigation.items]) as MenuItem[];

    return (
        <Box component="main" sx={{ width: '100%', flexGrow: 1, p: isRedesign ? 0 : { xs: 2, sm: 3 } }}>
            {notification && showBanner && <NotificationBanner notification={notification} onClose={closeBanner} />}
            <Toolbar />
            <Breadcrumbs navigation={{ items: flattenedMenuItems }} title titleBottom card={false} divider={false} />
            <Outlet />
        </Box>
    );
};

export default Main;
